import { createAction } from 'redux-actions';
import actions from '../actionTypes';

const {
    START_PLAY,
    END_PLAY,
    NEXT_PAGE,
    NEXT_PAGE_WITHOUT_FRAGMENT,
    PREV_PAGE_WITHOUT_FRAGMENT,
    PREV_PAGE,
    JUMP_PAGE,
    SHOW_DIALOG,
    HIDE_DIALOG,
    TURN_ON_LASER,
    TURN_OFF_LASER,
    TURN_ANNOTATION,
    BE_MASTER,
    BE_AUDIENCE,
    END_REMOTE_PLAY,
    // MASTER_PEN_UPDATED,
    SENT_PEN_DATA,
    AUDIENCE_PEN_DRAWING,
    SLIDE_SCALE_CHANGED,
    NEXT_PAGE_REMOTE,
    PREV_PAGE_REMOTE,
    JUMP_PAGE_REMOTE,
    ALLOW_FLIP_PAGE,
    FORIBD_FLIP_PAGE,
    SYCN_WITH_MASTER,
    INIT_CLIENT_WIDTHHEIGHT,
    INTERACTIVE_ANIM_NEXT,
    INTERACTIVE_ANIM_RESET,
    STOP_MAIN_ANIM,
    HANDLE_FIRST_ANIM_WITH_EFFECT,
    START_TRANSITION,
    STOP_TRANSITION,
    SHOULD_STOP_TRANSITION,
} = actions;

export const startPlay = createAction(START_PLAY);
export const endPlay = createAction(END_PLAY);
export const nextPage = createAction(NEXT_PAGE);
export const prevPage = createAction(PREV_PAGE);
export const nextPageWithoutFragment = createAction(NEXT_PAGE_WITHOUT_FRAGMENT);
export const prevPageWithoutFragment = createAction(PREV_PAGE_WITHOUT_FRAGMENT);
export const jumpToPage = createAction(JUMP_PAGE, page => page);
export const showDialog = createAction(SHOW_DIALOG);
export const hideDialog = createAction(HIDE_DIALOG);
export const turnOnLaser = createAction(TURN_ON_LASER);
export const turnOffLaser = createAction(TURN_OFF_LASER);
export const turnAnnotation = createAction(TURN_ANNOTATION, payload => payload);
export const beMaster = createAction(BE_MASTER);
export const beAudience = createAction(BE_AUDIENCE);
export const endRemotePlay = createAction(END_REMOTE_PLAY);

// export const masterPenUpdated = createAction(MASTER_PEN_UPDATED, pen => pen);
export const sentPenData = createAction(SENT_PEN_DATA);
export const audiencePenDrawing = createAction(AUDIENCE_PEN_DRAWING);
export const slideScaleChanged = createAction(SLIDE_SCALE_CHANGED, scale => scale);

export const nextPageRemote = createAction(NEXT_PAGE_REMOTE);
export const prevPageRemote = createAction(PREV_PAGE_REMOTE);
export const jumpPageRemote = createAction(JUMP_PAGE_REMOTE, pageAndFragment => pageAndFragment);
export const allowFlipPage = createAction(ALLOW_FLIP_PAGE);
export const forbidFlipPage = createAction(FORIBD_FLIP_PAGE);
export const syncWithMaster = createAction(SYCN_WITH_MASTER);
export const initWithHeight = createAction(INIT_CLIENT_WIDTHHEIGHT);
export const interactiveAnimNext = createAction(INTERACTIVE_ANIM_NEXT);
export const interactiveAnimReset = createAction(INTERACTIVE_ANIM_RESET);
export const stopMainAnim = createAction(STOP_MAIN_ANIM);
export const handleFirstAnim = createAction(HANDLE_FIRST_ANIM_WITH_EFFECT);
export const stopTransition = createAction(STOP_TRANSITION);
export const startTransition = createAction(START_TRANSITION);
export const shouldStopTransition = createAction(SHOULD_STOP_TRANSITION);
